module.exports = __webpack_public_path__ + "static/media/investors-business-daily-logo.149ba246.png";